var render, staticRenderFns
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4f11d02')) {
      api.createRecord('d4f11d02', component.options)
    } else {
      api.reload('d4f11d02', component.options)
    }
    
  }
}
component.options.__file = "frontend/static/js/components/pagination.vue"
export default component.exports